<template>
    <div id="statisticspage">
        <div class="leftcolumn grid grid-cols-12 items-stretch gap-8 p-4">
            <div class="menuitem" :disabled="running.productionTimes">
                <button
                    class="invisible-button"
                    :disabled="running.productionTimes"
                    @click="
                        onClick(
                            'productionTimes',
                            trans('pages.statistics.production_times.message'),
                            '/productioninfo/exportProductiontimes/'
                        )
                    ">
                    <h2>{{ trans('pages.statistics.production_times.title') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fa fa fa-file-excel-o fa-5x" />
                    </div>
                </button>
            </div>
            <div class="menuitem" :disabled="running.productionTotals">
                <button
                    class="invisible-button"
                    :disabled="running.productTotals"
                    @click="
                        onClick(
                            'productTotals',
                            trans('pages.statistics.product_totals.message'),
                            '/productioninfo/exportProductionNumbers/'
                        )
                    ">
                    <h2>{{ trans('pages.statistics.product_totals.title') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fa fa fa-file-excel-o fa-5x" />
                    </div>
                </button>
            </div>
            <div class="menuitem" :disabled="running.paintListOverview">
                <button
                    class="invisible-button"
                    :disabled="running.paintListOverview"
                    @click="
                        onClick(
                            'paintListOverview',
                            trans('pages.statistics.paint_list_overview.message'),
                            '/optimizedpaintlist/exportOverview/'
                        )
                    ">
                    <h2>{{ trans('pages.statistics.paint_list_overview.title') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fa fa fa-paint-brush fa-5x" />
                    </div>
                </button>
            </div>
            <div class="menuitem" :disabled="running.paintlistDetails">
                <button
                    class="invisible-button"
                    :disabled="running.paintlistDetails"
                    @click="
                        onClick(
                            'paintlistDetails',
                            trans('pages.statistics.paint_list_details.message'),
                            '/optimizedpaintlist/exportDetails/'
                        )
                    ">
                    <h2>{{ trans('pages.statistics.paint_list_details.title') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fa fa fa-table fa-5x" />
                    </div>
                </button>
            </div>
            <div class="menuitem" :disabled="running.errorReports">
                <button
                    class="invisible-button"
                    :disabled="running.errorReports"
                    @click="
                        onClick(
                            'errorReports',
                            trans('pages.statistics.error_reports.message'),
                            '/errorReportError/exportDetails/'
                        )
                    ">
                    <h2>{{ trans('pages.statistics.error_reports.title') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fas fa-exclamation-circle fa-5x" />
                    </div>
                </button>
            </div>
            <div class="menuitem">
                <router-link to="/export-products" class="invisible-button">
                    <h2>{{ trans('pages.statistics.export_products.title') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-file-excel-o fa-5x" />
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../api/api.js';
import { showInfoMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            running: {
                productionTimes: false,
                paintListOverview: false,
                paintlistDetails: false,
                productTotals: false,
                errorReports: false,
            },
        };
    },
    methods: {
        getDatesPayload() {
            const d = new Date();

            d.setDate(d.getDate() - 1);

            return {
                from: d.getFullYear() + '-01-01',
                to:
                    d.getFullYear() +
                    '-' +
                    (d.getMonth() + 1) +
                    '-' +
                    d.getDate(),
            };
        },
        onClick(name, msg, requestUrl) {
            this.running[name] = true;
            showInfoMessage(msg);
            const url = api.createGetUrl(requestUrl, this.getDatesPayload());
            window.open(url);
            this.running[name] = false;
        },
    },
};
</script>
